import styled from 'styled-components'

export const PageWrapper = styled.div`
  background: ${props => props.theme.colors.white};
  padding: 0 0 30px 0;
`
